const ACTION_TYPES = Object.freeze({
    GET_USER: "GET_USER",
    SET_DATA: "SET_DATA",
    GET_WORKBOOK_DATA: "GET_WORKBOOK_DATA",
    SET_WORKBOOK_DATA: "SET_WORKBOOK_DATA",
    GET_SHEET_DATA: "GET_SHEET_DATA",
    SET_SHEET_DATA: "SET_SHEET_DATA",
    DELETE_SHEET_ITEM: "DELETE_SHEET_ITEM",
    CREATE_NEW_SHEET: "CREATE_NEW_SHEET",
    DELETE_WORKBOOK_ITEM: "DELETE_WORKBOOK_ITEM",
    SET_SHEET_ROW_DATA: "SET_SHEET_ROW_DATA",
    EMPTY_SHEET_HANDLEING: "EMPTY_SHEET_HANDLEING",
    SET_CURRENT_ROW_OBJECT: "SET_CURRENT_ROW_OBJECT",
    GET_SHEET_ID:"GET_SHEET_ID",
    SET_CURRENT_SHEET_INFO:"SET_CURRENT_SHEET_INFO",
    SET_FULLSCREEN:"SET_FULLSCREEN",
    SET_FOOTER_FOR_WORKSPACES: "SET_FOOTER_FOR_WORKSPACES",
    SET_GLOBAL_STYLE:"SET_GLOBAL_STYLE",
    SET_USERWORKSPACETREE:"SET_USERWORKSPACETREE",
    SET_TEMPLATE_TREE:"SET_TEMPLATE_TREE",
    SET_SHARED_SHEET:"SET_SHARED_SHEET",
    SET_CALENDAR_EVENTS:"SET_CALENDAR_EVENTS",
    SET_ALL_USERS:"SET_ALL_USERS",
    DOWNLOAD_WORKBOOK:"DOWNLOAD_WORKBOOK",
    SET_ISSHARED:'SET_ISSHARED',
    SET_UPDATED_DATE: "SET_UPDATED_DATE",
    SET_SEARCHFIELD:'SET_SEARCHFIELD',
    RESET_SHEET_STATE:'RESET_SHEET_STATE',
    SET_FLAGTOUPDATESHEETONONEDRIVE:'SET_FLAGTOUPDATESHEETONONEDRIVE',
    SET_RESETISSHEETUPDATEDREFAFTERINACTIVITY:'SET_RESETISSHEETUPDATEDREFAFTERINACTIVITY',
    SET_SETSHAREDWITHMEWORKBOOKS : 'SET_SETSHAREDWITHMEWORKBOOKS',
    SET_ISUSERACTIVITYALREADYINDB : 'SET_ISUSERACTIVITYALREADYINDB',
    SET_IS_WORKBOOK_IMPORTING:'SET_IS_WORKBOOK_IMPORTING',
    SET_IS_SHEET_SHARE_START:'SET_IS_SHEET_SHARE_START',
    SET_IS_WORKBOOK_DELETING:'SET_IS_WORKBOOK_DELETING',
    SET_IS_WORKBOOKDATAFETCHED:'SET_IS_WORKBOOKDATAFETCHED',
    SET_IS_SHEET_DELETING:'SET_IS_SHEET_DELETING',
    SET_WORKSPACEWORKBOOKS : 'SET_WORKSPACEWORKBOOKS',
    //Undo Redo ACTION_TYPES
    SET_ROW_DATA: "SET_ROW_DATA",
    SET_COLUMN_DEFS: "SET_COLUMN_DEFS",
    EDIT_CELL_VALUE: "EDIT_CELL_VALUE", 
    GET_NOTES:"GET_NOTES",
    SET_NOTES:"SET_NOTES",
    SET_UPDATED_TIME:"SET_UPDATED_TIME",
    SET_USER_ACTIVITY_INFO:"SET_USER_ACTIVITY_INFO",
    SET_SHARED_SHEET_ACCESS:"SET_SHARED_SHEET_ACCESS",
    SET_WORKSPACE_DATA:"SET_WORKSPACE_DATA",
    SET_WORKBOOKSEXPORTED : "SET_WORKBOOKSEXPORTED",
    SET_WORKSPACE_EXPAND : "SET_WORKSPACE_EXPAND",
    //notification
    SET_NOTIFICATION_DATA: "SET_NOTIFICATION_DATA",
    CREATE_TEMPLATE: 'CREATE_TEMPLATE',
    DELETE_TEMPLATE :'DELETE_TEMPLATE',
    SET_TEMPLATE_DATA:'SET_TEMPLATE_DATA',
    REMOVE_USER:'REMOVE_USER',
    SET_AUTH_LOADING:'SET_AUTH_LOADING',
    SET_ISAZUREDEVOPS_CONNECTED:'SET_ISAZUREDEVOPS_CONNECTED',

    //summar rows
    SET_CLONE_DATA_OF_ROWS: "SET_CLONE_DATA_OF_ROWS",

    // Sheet Copy
    START_COPY_SHEET : 'START_COPY_SHEET',
    SET_SESSIONID:"SET_SESSIONID", 

    SET_IS_CHECKINAGENT_ROWS_TO_BE_MERGED: 'SET_IS_CHECKINAGENT_ROWS_TO_BE_MERGED',

    SET_FALLBACKERROR: 'SET_FALLBACKERROR',

    SET_ISONEDRIVESERVICEWORKING: "SET_ISONEDRIVESERVICEWORKING",
    SET_TRIGGERSAVE: "SET_TRIGGERSAVE",

    //Row Copy Paste
    SET_COPIED_ROWS: "SET_COPIED_ROWS",
    CLEAR_COPIED_ROWS: "CLEAR_COPIED_ROWS",

})

export default ACTION_TYPES 